import { useCurrencies } from 'contexts'
import { useBlueChipArtists } from 'hooks/artists/useBlueChipArtists'
import { ArtworksCategories } from 'hooks/artworks/useArtworksCategoriesFilters'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { getArtworksCategoryUrl } from 'utils/urls'

export function useArtworksNavigationItems() {
  const { t } = useTranslation('common')
  const { formatWithUserCurrency } = useCurrencies()
  const { data: artists = [] } = useBlueChipArtists()

  const mediums = useMemo(() => {
    return [
      {
        label: t('extended_nav.prints'),
        href: getArtworksCategoryUrl(ArtworksCategories.prints),
      },
      {
        label: t('extended_nav.sculptures'),
        href: getArtworksCategoryUrl(ArtworksCategories.sculptures),
      },
      {
        label: t('extended_nav.collectibles'),
        href: getArtworksCategoryUrl(ArtworksCategories.collectibles),
      },
      {
        label: t('extended_nav.photography'),
        href: getArtworksCategoryUrl(ArtworksCategories.photography),
      },
      {
        label: t('extended_nav.art_books'),
        href: getArtworksCategoryUrl(ArtworksCategories.books),
      },
      // {
      //   label: t('extended_nav.original'),
      //   href: getArtworksCategoryUrl(ArtworksCategories.original),
      // },
    ]
  }, [])

  const prices = useMemo(() => {
    return [
      {
        label: t('extended_nav.finds_under_1000', {
          price: formatWithUserCurrency(1000),
        }),
        href: getArtworksCategoryUrl(ArtworksCategories.findsUnder1000),
      },
      {
        label: t('extended_nav.mid_priced_art', {
          min: formatWithUserCurrency(1000),
          max: formatWithUserCurrency(5000),
        }),
        href: getArtworksCategoryUrl(ArtworksCategories.midPricedArt),
      },
      {
        label: t('extended_nav.rare_luxury_artworks'),
        href: getArtworksCategoryUrl(ArtworksCategories.rareLuxuryArt),
      },
    ]
  }, [])

  const sizes = useMemo(() => {
    return [
      {
        label: t('extended_nav.size_small'),
        href: getArtworksCategoryUrl(ArtworksCategories.small),
      },
      {
        label: t('extended_nav.size_medium'),
        href: getArtworksCategoryUrl(ArtworksCategories.medium),
      },
      {
        label: t('extended_nav.size_large'),
        href: getArtworksCategoryUrl(ArtworksCategories.large),
      },
    ]
  }, [])

  return { mediums, prices, artists, sizes }
}
